module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/socials/google-9e857dd86f938b62de4f26358fccc82f.svg";